import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './footer-accordion-item.scss.js';
import { generateUniqueId } from '../../../utilities/dom-helpers/index.js';

const PREFIX_BTN = 'fa-btn-';
const PREFIX_PANEL = 'fa-panel-';
const ARROW_UP_SVG = $ `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12.0002 10.2568L4.44504 17.8119C4.08988 18.1671 3.63786 18.3446 3.08898 18.3446C2.54011 18.3446 2.08809 18.1671 1.73293 17.8119C1.37777 17.4567 1.2002 17.0047 1.2002 16.4559C1.2002 15.907 1.37777 15.455 1.73293 15.0998L10.6441 6.18859C10.8379 5.99487 11.0477 5.85765 11.2737 5.77693C11.4997 5.69621 11.7419 5.65585 12.0002 5.65585C12.2585 5.65585 12.5006 5.69621 12.7267 5.77693C12.9527 5.85765 13.1625 5.99487 13.3562 6.18859L22.2675 15.0998C22.6226 15.455 22.8002 15.907 22.8002 16.4559C22.8002 17.0047 22.6226 17.4567 22.2675 17.8119C21.9123 18.1671 21.4603 18.3446 20.9114 18.3446C20.3625 18.3446 19.9105 18.1671 19.5554 17.8119L12.0002 10.2568Z" fill="currentColor"/></svg>`;
class FooterAccordionItem extends s {
    constructor() {
        super();
        this.label = '';
        this.open = false;
        this.toggle = () => {
            this.open = !this.open;
            this.setAttribute('data-open', String(this.open));
            this.dispatchEvent(new CustomEvent('fa-toggle', { bubbles: true, composed: true }));
        };
        this.onKey = (e) => {
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                this.toggle();
            }
        };
        this.uid = generateUniqueId();
        this.setAttribute('data-open', 'false');
    }
    static get observedAttributes() {
        return [...super.observedAttributes, 'data-open'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name !== 'data-open')
            return;
        const nextOpen = newValue === 'true';
        if (this.open === nextOpen)
            return;
        this.open = nextOpen;
    }
    updated(changedProperties) {
        var _a;
        super.updated(changedProperties);
        if (!changedProperties.has('open'))
            return;
        const panel = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.fa-item__panel');
        if (!panel)
            return;
        if (this.open) {
            panel.removeAttribute('hidden');
            panel.removeAttribute('inert');
        }
        else {
            panel.setAttribute('hidden', '');
            panel.setAttribute('inert', '');
        }
    }
    render() {
        const btnId = `${PREFIX_BTN}${this.uid}`;
        const panelId = `${PREFIX_PANEL}${this.uid}`;
        return $ `<div class="fa-item"><button id="${btnId}" type="button" class="fa-item__button" aria-expanded="${String(this.open)}" aria-controls="${panelId}" @click="${this.toggle}" @keydown="${this.onKey}"><span class="fa-item__label">${this.label}</span> <span class="fa-item__icon-visual" aria-hidden="true">${ARROW_UP_SVG}</span></button><div id="${panelId}" class="fa-item__panel" role="region" aria-labelledby="${btnId}" aria-hidden="${String(!this.open)}" ?hidden="${!this.open}"><div class="fa-item__content"><slot></slot></div></div></div>`;
    }
}
FooterAccordionItem.styles = css_248z;
__decorate([
    e({ type: String })
], FooterAccordionItem.prototype, "label", void 0);
__decorate([
    t()
], FooterAccordionItem.prototype, "open", void 0);
customElements.define('footer-accordion-item', FooterAccordionItem);

export { FooterAccordionItem };
